import OrderFinishedCargoOrdersUnbilledListResponse, {
  OrderFinishedCargoOrdersUnbilledListResponseDataItemLackingRailyBillings,
  OrderFinishedCargoOrdersUnbilledListResponseDataItem,
  OrderFinishedCargoOrdersUnbilledListResponseData,
} from "../../../../api/raily/order/finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list-response";
import OrderFinishedCargoOrdersUnbilledList, {
  OrderFinishedCargoOrdersUnbilledListItem,
  OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings,
} from "./order-finished-cargo-orders-unbilled-list";

const createLackingBilling = (
  lackingBilling: OrderFinishedCargoOrdersUnbilledListResponseDataItemLackingRailyBillings,
): OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings => {
  switch (lackingBilling) {
    case OrderFinishedCargoOrdersUnbilledListResponseDataItemLackingRailyBillings.CARGO_RAILY:
      return OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings.CARGO_RAILY;
    case OrderFinishedCargoOrdersUnbilledListResponseDataItemLackingRailyBillings.RAILY_TAXI:
      return OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings.RAILY_TAXI;
    case OrderFinishedCargoOrdersUnbilledListResponseDataItemLackingRailyBillings.TAXI_RAILY:
      return OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings.TAXI_RAILY;
  }
};

const createLackingBillings = (
  lackingBillings: OrderFinishedCargoOrdersUnbilledListResponseDataItemLackingRailyBillings[],
): OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings[] => {
  return lackingBillings.map(createLackingBilling);
};

const createDataItem = (
  item: OrderFinishedCargoOrdersUnbilledListResponseDataItem,
): OrderFinishedCargoOrdersUnbilledListItem => {
  return {
    client: item.client,
    dispatch: item.dispatch,
    drivers: item.drivers,
    externalId: item.externalId,
    humanId: item.humanId,
    isCancelled: item.isCancelled,
    lackingRailyBillings: createLackingBillings(item.lackingRailyBillings),
    passengers: item.passengers,
    rideAddresses: item.rideAddresses,
    startTime: item.startTime,
    taxiCorporations: item.taxiCorporations,
    uuid: item.id,
  };
};

const createDataItems = (
  items: OrderFinishedCargoOrdersUnbilledListResponseDataItem[],
): OrderFinishedCargoOrdersUnbilledListItem[] => {
  return items.map(createDataItem);
};

const createData = (
  data: OrderFinishedCargoOrdersUnbilledListResponseData,
): OrderFinishedCargoOrdersUnbilledList => {
  return {
    data: createDataItems(data.data),
    totalCount: data.totalCount,
  };
};

const create = (
  response: OrderFinishedCargoOrdersUnbilledListResponse,
): OrderFinishedCargoOrdersUnbilledList => {
  return createData(response.data);
};

const orderFinishedCargoOrdersUnbilledListFactory = {
  create,
};

export default orderFinishedCargoOrdersUnbilledListFactory;
